export default "__VITE_ASSET__Bh$l5$3E__"